var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSend = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 15 12",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m.34 12 13.994-6L.34 0 .333 4.667l10 1.333-10 1.333L.34 12Z"
})));
export default SvgSend;